/*
 * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *
 * All Rights Reserved.
 *
 * These materials are unpublished, proprietary, confidential source code of
 * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 * of hSenid Mobile Solutions (Pvt) Limited.
 *
 * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 * property rights in these materials.
 *
 */
import { API_URL } from "./config.json";

export const routerBasePath = getRouterBasePath();
export const apiBasePath = getApiBasePath();

function getRouterBasePath() {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    return "";
  } else {
    return "/appstore-v4-consumer";
  }
}

function getApiBasePath() {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    return "http://localhost:20601";
  } else {
    return API_URL;
  }
}
